// extracted by mini-css-extract-plugin
export var dividerLine = "_3s-0";
export var errorBackground = "_3s-1";